import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { BREAKPOINT_BELOW_XS, BREAKPOINT_BELOW_M } from '../../../constants';

const PageContentSC = styled.section`
  width: 23.25rem;
  background-color: #ffffff;

  @media (${BREAKPOINT_BELOW_M}) {
    width: 21.5rem;
  }

  @media (${BREAKPOINT_BELOW_XS}) {
    width: 100%;
  }
`;

const PageContent = ({ className, children, ...rest }) => (
  <>
    <PageContentSC className={className} data-testid="pageContent" {...rest}>
      {children}
    </PageContentSC>
  </>
);

PageContent.defaultProps = {
  className: null,
};

PageContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PageContent;
